/** GET de grupos empresa: devuelve los grupos con sus empresas embebidas. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";
import { GrupoEmpresa } from "@/types";

export const GETGruposEmpresa = () =>
  apiCall<GrupoEmpresa[]>({
    method: "get",
    url: API_ENDPOINTS.GET_GRUPOS_EMPRESA,
  });
